import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  convertCase,
  generateBatchNumber,
  validateDecimalInput,
} from "../../../SharedFiles/Helper/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  GetDisassembleRecipt,
  postDisassembleReceipt,
} from "../../../APIServices/ProductionService/DisassembleService/DisassembleThunk";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import CommonDialog from "../../../SharedFiles/CommonModal/CommonDialog";
import QRCodeGenerator from "../../../SharedFiles/QRCode/qrGenerator";
import { toast, Toaster } from "react-hot-toast";
import {
  showDeleteConfirmation,
  showSubmitConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import { useTranslation } from "react-i18next";
import { useQRModal } from "../../../../Context/QrContext";
import DisassembleTable from "./DiassembleTable";

const DisassembleReceipt = ({
  selectedbatch,
  setSelectedBatch,
  callInProgress,
  setCallInProgress,
  dataUpdate,
  setDataUpdate,
  tableBody,
  setTableBody,
  groupedData,
  openAddBatch,
  setOpenAddBatch,
  getValues,
  setGetValues,
}) => {
  const header = [
    "item_Code",
    "item_Name",
    "batch_Number",
    "quantity",
    "total_Cuts",
    "remaining_Cuts",
  ];
  const [qrScanResult, setQrScanResult] = useState(null);
  const {
    DisassembleIssue,
    DisassembleRecipt,
    DisassembleReciptList,
    error,
    loading,
  } = useSelector((state) => state.Disassemble);
  // const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [InProgress, setInProgress] = useState({
    receiptCall: false,
    batchCall: false,
    receiptList: false,
  });
  const [openManual, setOpenManual] = useState(false);
  // const [getValues, setGetValues] = useState([]);
  // const [openAddBatch, setOpenAddBatch] = useState(false);
  // const [receiptTable, setReceiptTable] = useState([]);
  const [inputField, setInputField] = useState(["item_Code", "item_Name"]);
  const [searchData, setSearchData] = useState([]);
  const [QRmodalOpen, setQRmodalOpen] = useState(false);
  const [lineIds, setLineids] = useState({});
  const [QRdata, setQrData] = useState("");
  const [addLine, setAddLine] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  // const [printedRows, setPrintedRows] = useState([]);
  const [disabledFields, setDisabledFields] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [selectedItem, setSelectedItem] = useState([]);
  const { PrintLabel, setPrintedRows, printedRowss } = useQRModal();
  const [values, setValues] = useState({
    Batch_Number: "",
    docEntry: "",
    itemCode: "",
    plannedQty: "",
    uom: "",
    warehouse: "",
  });
  const [receiptItem, setReceiptItem] = useState({
    item_Code: "",
    item_Name: "",
    planned_Qty: "",
    no_of_Cuts: "",
    batch_Number: "",
    weight: "",
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (tableBody.length > 0) {
        const message =
          "Are you sure you want to leave? Changes you made may not be saved.";
        event.returnValue = message; // Standard for most browsers
        return message; // For some older browsers
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [tableBody]);

  const tableHeader = useMemo(() => {
    return DisassembleRecipt?.length > 0
      ? Object.keys(DisassembleRecipt[0])
          .concat("issues_Batch", "Remarks")
          .filter(
            (header) =>
              header !== "docEntry" &&
              header !== "docNum" &&
              header !== "max" &&
              header !== "no_of_Cuts" &&
              header !== "remaining_Cuts" &&
              header !== "cuts_Per_Coil" &&
              header !== "planned_Qty" &&
              header !== "no_of_Coils"
          )
      : [];
  }, [DisassembleRecipt]);

  useEffect(() => {
    if (DisassembleRecipt) {
      if (dataUpdate) {
        setDataUpdate(false);
        const diaAssemble = DisassembleIssue && DisassembleIssue[0];
        setValues(diaAssemble);

        // setSelectedBatch(diaAssemble);
      }
    }
    // if(callInProgress.receiptlist && DisassembleReciptList){
    //   setCallInProgress((prev) => ({
    //     ...prev,
    //     receiptlist: false,
    //   }));
    //   setTableBody(DisassembleReciptList);
    // }

    // else {
    //   if (
    //     (DisassembleIssue ? DisassembleIssue : "") &&
    //     !error.DisassembleIssueError &&
    //     dataUpdate
    //   ) {
    //     setValues(DisassembleIssue[0]);
    //     setSelectedBatch(DisassembleIssue[0]);
    //     dispatch(GetDisassembleRecipt({ DocEntry: DisassembleIssue[0].pur_Num }));
    //     setDataUpdate(false);
    //   }
    // }
  }, [DisassembleIssue, DisassembleRecipt, DisassembleReciptList, dataUpdate]);

  // Handle closing the dialog
  const handleCloseDialog = () => {
    // setOpenDialog(false);
    setErrorMessage({});
    setOpenAddBatch(false);
    setAddLine(true);
    setEditMode(false);
    // setOpenManual(false);
  };

  const handleSearchDrop = (item, fieldname) => {
    setErrorMessage({});
    if (fieldname === "item_Code" || fieldname === "item_Name") {
      // Access batchNumber and itemCode
      const batchNumber = selectedbatch?.batch_Number;
      const itemCode = item.item_Code;
      const cutsPerCoil = parseInt(item.cuts_Per_Coil || 0);

      // Count matching entries in groupedData
      let itemMatchCount = 0;

      if (groupedData && groupedData[batchNumber]) {
        itemMatchCount = groupedData[batchNumber].filter(
          (entry) => entry.item_Code === itemCode
        ).length;
      }

      if (itemMatchCount >= cutsPerCoil) {
        toast.error(t("Max cuts per coil reached for this batch and item"));
        return; // Stop execution
      }
      const batchNo = generateBatchNumber(item, item.max);
      setGetValues((prevValues) => ({
        ...prevValues,
        ...item,
        batch_Number: batchNo,
      }));
    }
    
    
  };

  const handleAddBatch = () => {
    setDisabledFields(["no_of_Cuts", "planned_Qty", "batch_Number"]);
    setOpenManual(true);
    setOpenAddBatch(true);
    setSearchData(DisassembleRecipt);
    setGetValues(receiptItem);
    setInputField(["item_Code", "item_Name"]);
    setInProgress((prev) => ({
      ...prev,
      batchCall: true,
    }));
  };

  const handleValueChange = (e, header) => {
    let value = e.target.value;
    if (header === "weight") {
      // If the value is empty, clear the state or set it to an empty string
      const {
        isValid,
        values: cleanedValue,
        error,
      } = validateDecimalInput(value);
      if (isValid) {
        setErrorMessage({});
        value = cleanedValue;
      } else {
        value = cleanedValue;
      }
    }

    setGetValues((prevState) => ({
      ...prevState,
      [header]: value, // For other fields, keep the value as is
    }));
  };

  const validateInputs = () => {
    const weight = parseFloat(getValues.weight || 0);
    let errors = {};

    if (InProgress.batchCall && (!weight || weight === 0)) {
      errors.weight = `Weight can't be 0 or empty!`;
    }

    const prevWeight = tableBody.reduce(
      (acc, item) => acc + (parseFloat(item.weight) || 0),
      0
    );
    const totalWeight = weight;
    const remainingQuantity = DisassembleIssue[0]?.quantity - totalWeight;

    if (remainingQuantity < 0) {
      errors.remaining = "Weight exceeds batch quantity";
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      totalWeight,
      remainingQuantity,
    };
  };

  const handleSubmit = async () => {
    const { isValid, errors, totalWeight, remainingQuantity } =
      validateInputs();

    if (!isValid) {
      setErrorMessage(errors);
      setOpenAddBatch(true);
      if (errors.remaining) toast.error(t(errors.remaining));
      return;
    }

    const currentDate = new Date().toLocaleDateString();

    const newItem = {
      ...getValues,
      weight: parseFloat(getValues.weight || 0),
      overall_Weight: parseFloat(getValues.weight || 0), // Or compute as needed
      CreatedDate: currentDate,
    };

    // Optional: Update tableBody and selectedBatch state if needed
    // setTableBody([newItem]);

    // Inside handleSubmit
    // setTableBody((prev) => [...prev, newItem]);

    const issuesProduction = [
      {
        prodNum: values.pur_Num,
        ItemCode: values.item_Code,
        ItemName: values.item_Name,
        IssuesAccNo: DisassembleIssue[0]?.issAccNo,
        issuesRemarks: getValues.Remarks || "",
        issuesQuantity: totalWeight,
        batchNum: values.batch_Number,
        batchQty: values.quantity,
        rowId: 0,
      },
    ];

    const goodReceipt = [
      {
        itemCode: newItem.item_Code,
        ItemName: newItem.item_Name,
        prodEntry: newItem.docEntry,
        quantity: newItem.weight,
        ReciptAccNo: values.recptAccNo,
        Price: DisassembleIssue[0]?.price,
        remarks: getValues.Remarks || "",
        batchNum: newItem.batch_Number,
        batchQty: newItem.weight,
      },
    ];

    const batchData = [
      {
        batchNumber: newItem.batch_Number,
        batchDetails: JSON.stringify({
          BatchNumber: newItem.batch_Number,
          PONumber: values.order_Num,
          Itemcode: newItem.item_Code,
          ItemName: newItem.item_Name,
          ActualWt: newItem.weight,
          CreatedDate: currentDate,
        }),
        itemName: newItem.item_Name,
        itemCode: newItem.item_Code,
      },
    ];

    const postData = [{ issuesProduction, goodReceipt, batchData }];

    showSubmitConfirmation(() => {
      setCallInProgress((prev) => ({
        ...prev,
        postRecipt: true,
      }));
      // const data = {
      //   Order_Number: getValues.docNum,
      //   batch_Number: getValues.batch_Number,
      //   item_Code: getValues.item_Code,
      //   item_Name: getValues.item_Name,
      //   Actual_Weight: getValues.weight,
      //   CreatedDate: currentDate
      // };
      // PrintLabel(data, 0, "GRPO", '');
      dispatch(postDisassembleReceipt(postData));
      setSelectedBatch((prevState) => ({
        ...prevState,
        quantity: remainingQuantity,
      }));
    });
  };

  // const handleSubmit = async (e) => {
  //   // e.preventDefault();
  //   const newItem = await handleAddDialog();

  //   if (!newItem) {
  //     toast.error(t("Add a receipt before submitting"));
  //     return;
  //   }
  //   const combinedTable = [...tableBody, newItem];
  //   // if (tableBody.length > 0) {
  //   // const totalWeight = parseFloat(combinedTable.weight || 0);
  //   // const maxQuantity = parseFloat(DisassembleIssue[0]?.quantity || 0);

  //   // if (totalWeight > maxQuantity) {
  //   //   const weightErrorMessage = `Total weight (${totalWeight}) exceeds the maximum allowed weight (${values.quantity}).`;
  //   //   toast.error(weightErrorMessage);
  //   //   return;
  //   // }
  //   const totalWeight = newItem.weight
  //   showSubmitConfirmation(() => {
  //     const issuesProduction = [values].map((input) => ({
  //       prodNum: input.pur_Num,
  //       ItemCode: input.item_Code,
  //       ItemName: input.item_Name,
  //       IssuesAccNo: DisassembleIssue[0].issAccNo,
  //       issuesRemarks: getValues.Remarks || 'str',
  //       issuesQuantity: totalWeight,
  //       batchNum: input.batch_Number,
  //       batchQty: input.quantity,
  //       rowId: 0,
  //     }));

  //     const goodReceipt = [{
  //       itemCode: newItem.item_Code,
  //       ItemName: newItem.item_Name,
  //       prodEntry: newItem.docEntry,
  //       quantity: newItem.weight,
  //       ReciptAccNo: values.recptAccNo,
  //       remarks: "string",
  //       batchNum: newItem.batch_Number,
  //       batchQty: newItem.weight,
  //     }];
  //     //
  //     const currentDate = new Date().toLocaleDateString();
  //     //   // const batchData = tableBody.map((row) => ({
  //     //   //   batchNumber: row.batch_Number,
  //     //   //   batchDetails: JSON.stringify({
  //     //   //     BatchNumber: row.batch_Number,
  //     //   //     PONumber: values.po_Doc_Num,
  //     //   //     Itemcode: row.item_Code,
  //     //   //     ItemName: row.item_Name,
  //     //   //     ActualWt: row.actual_Gross_Wt,
  //     //   //     CreatedDate: currentDate,
  //     //   //   }),
  //     //   //   itemName: row.item_Name,
  //     //   //   itemCode: row.item_Code,
  //     //   // }));
  //     const batchData = [{
  //       batchNumber: newItem.batch_Number,
  //       batchDetails: JSON.stringify({
  //         BatchNumber: newItem.batch_Number,
  //         PONumber: values.order_Num,
  //         Itemcode: newItem.item_Code,
  //         ItemName: newItem.item_Name,
  //         ActualWt: newItem.weight,
  //         CreatedDate: currentDate,
  //       }),
  //       itemName: newItem.item_Name,
  //       itemCode: newItem.item_Code,
  //     }];

  //     const postData = { issuesProduction, goodReceipt, batchData };
  //     setCallInProgress((callInProgress) => ({
  //       ...callInProgress,
  //       postRecipt: true,
  //     }));
  //     dispatch(postDisassembleReceipt(postData));
  //   });
  //   // } else {
  //   //   toast.error(t("Add a receipt before submitting"));
  //   // }
  // };

  return (
    <div className="secondayMain">
      <div>
        <CommonDialog
          openDialog={openAddBatch}
          inputField={inputField}
          handleCloseDialog={handleCloseDialog}
          // hanldeScannerClick={hanldeScannerClick}
          openManual={openManual}
          getValues={getValues}
          setGetValues={setGetValues}
          SearchData={searchData}
          handleSearchDrop={handleSearchDrop}
          handleAddDialog={handleSubmit}
          InProgress={InProgress}
          inputHeader={tableHeader}
          editMode={editMode}
          errorMessage={errorMessage}
          pageName={"DisassembleReceipt"}
          disabledFields={disabledFields}
          // handleQrScan={handleQrScan}
          handleValueChange={handleValueChange}
        />
      </div>
      <div className="receipt-main">
        <div className="header-details col-xl-12">
          {header &&
            header.map((item, index) => (
              <div key={index} className="d-flex mb-1 col-xl-6">
                <div className="receipt-header-div ">
                  <p>{t(convertCase(item))} :</p>
                </div>
                <div className="receipt-detail-div ">
                  <p>{selectedbatch[item]}</p>
                </div>
              </div>
            ))}
        </div>
        <div className="receipt-table">
          <button className="button xs mb-1" onClick={handleAddBatch}>
            {t("Add Batch")}
          </button>
          <div className="tableMin">
            {/* <DynamicTable
              header={tableHeader}
              tablebody={tableBody}
              // onEdit={onEdit}
              pageName={"disassemblpage"}
            /> */}
            <DisassembleTable
              tableHeader={tableHeader}
              tablebody={tableBody}
              pageName={"disassemblpage"}
              selectedBatch={selectedbatch}
            />
          </div>
        </div>
      </div>
      {/* <div className="submit-button-container">
        {tableBody.length > 0 && (
          <button className="button xs" onClick={handleSubmit}>
            {t("Submit")}
          </button>
        )}
      </div> */}
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </div>
  );
};

export default DisassembleReceipt;
